import { Env } from '@stencil/core';
import { FoundJnmWebcom82BoletoNotification } from '../../found-jnm-webcom82-boleto-notification/found-jnm-webcom82-boleto-notification';
import ErpUtils from '../../../utils/ErpUtils';
import { isNavegadorSankhya } from '../../../utils/utils';
import ServiceBrokerCaller from '../../../utils/serviceBrokerCaller';
import ModuleInfoUtils from '../../../utils/ModuleInfoUtils';
import ServiceBrokerApiCaller, { API_PATHS } from '../../../utils/serviceBrokerApiCaller';

export default class PlgBoletoRapidoUtils {
  private static readonly DIALOG_ID = 'FINTECH_PLG_DIALOG';
  private static readonly MELHORES_PRATICAS_RESOURCE_ID = 'br.com.sankhya.turnkey.cfg.melhorespraticas';
  private static readonly CONTAS_RESOURCE_ID = 'br.com.sankhya.fin.cad.contas';
  private static readonly ID_ARTEFATO_MELHORES_PRATICAS_BOLETO_RAPIDO = 'mp.embbeded.found-jnm-webcom82.boleto_rapido';
  private static readonly PQL_VERSION = 'V2';

  static async canShowPlgBoletoRapido(): Promise<boolean> {
    if(isNavegadorSankhya(navigator.userAgent)) return false;

    if(await ModuleInfoUtils.fintechModuleExists() === false) {
      return await this.canShow();
    }

    const resourceId = (window as Window & { RESOURCEID?: string }).RESOURCEID || null;
    const codUsuario = (window.top as Window & { CODUSU?: number }).CODUSU || null;

    const exibirPlg = await ErpUtils.getConfigExibicao(`${this.PQL_VERSION}:${resourceId}.pqlfintech`, String(codUsuario));
    if(!exibirPlg) return false;

    return await ErpUtils.oferecerContratacao(resourceId, String(codUsuario));
  }

  static async canShow(): Promise<boolean> {
    const envTipoBase = Env.TIPO_BASE;
    const tipoBase =(window.top as Window & { TIPO_BASE?: string }).TIPO_BASE === envTipoBase;
    const resourceId = (window as Window & { RESOURCEID?: string }).RESOURCEID || null;
    const codUsuario = (window.top as Window & { CODUSU?: number }).CODUSU || null;
    try {

      if(isNavegadorSankhya(navigator.userAgent)) return false;

      console.warn('Verificando condições para exibir o componente PlgBoletoRapidoUtils - tipoBase:', tipoBase, 'envTipoBase:', envTipoBase);

      if(!tipoBase) return false;

      const isFormSubmitted = await ErpUtils.isformSubmitted();
      if(isFormSubmitted) return false;

      const exibirPql = await ErpUtils.getConfigExibicao(`${this.PQL_VERSION}:${resourceId}.pqlfintech`, String(codUsuario));
      if(!exibirPql) return false;

      const statusApi = await ErpUtils.findStatusApi(resourceId);
      if(!statusApi) return false;

      return true;
    } catch (ex) {
      console.warn(ex)
    }
    return false;
  }

  static handleMarketplaceOrder = async () => {
    console.warn('Evento mkpOrderConfirmed capturado em found-jnm-webcom82-plg-boleto-rapido');
    const resourceId = (window as Window & { RESOURCEID?: string }).RESOURCEID || null;
    const codUsuario = (window.top as Window & { CODUSU?: number }).CODUSU || null;
   
    ErpUtils.setLocalStorageSaveConfigExibicao(`V1:plg-found-jnm-webcom82-oferecercontratacao:${resourceId + codUsuario}`, false);

    const isMinVersion = await ModuleInfoUtils.melhoresPraticasCredenciamentoBoletoAtivo();

    if (isMinVersion) {
      PlgBoletoRapidoUtils.actionAfterOrder();
      return;
    }

    await this.showDialog();
  };

  static async showDialog(): Promise<void> {
    const dialog = this.createDialogIfNotExists() as Element & { componentOnReady?: () => Promise<void>; showDialog?: (options: Record<string, unknown>) => Promise<void> };
    await dialog.componentOnReady?.();
    await dialog.showDialog({
      title: 'Contratação finalizada!',
      message: 'Cadastre suas credenciais em: Contas > Boletos/Duplicatas > Boleto Rápido > Serviço API do Banco > botão Configurar Credenciais.',
      severity: 'success',
      showCloseButton: true,
      acceptLabel: 'Ir para Contas',
      cancelLabel: 'Fechar'
    });
  }

  private static createDialogIfNotExists(): Element {
    let dialogElement = document.getElementById(this.DIALOG_ID);
    
    if (dialogElement) {
      return dialogElement;
    }

    dialogElement = document.createElement('found-jnm-webcom82-dialog');
    dialogElement.setAttribute('id', this.DIALOG_ID);
    document.body.appendChild(dialogElement);

    return dialogElement;
  }

  /*
  * Versão atual do método actionAfterOrder (COM credenciamento pelo wizard), que abre a tela de de melhores práticas.
  */
  static actionAfterOrder(): void {
    try {
      const pk = { IDARTEFATO: this.ID_ARTEFATO_MELHORES_PRATICAS_BOLETO_RAPIDO };
      (window.top as Window & { workspace?: { openAppActivity: (resourceId: string, pk: Record<string, string>) => void } })?.workspace?.openAppActivity(this.MELHORES_PRATICAS_RESOURCE_ID, pk);
    } catch (e) {
      console.warn('[PlgBoletoRapidoUtils] actionAfterOrder erro:', e);
    }
  }

  /*
  * Versão legada do método actionAfterOrder (SEM credenciamento pelo wizard), que abre a tela de Contas a Receber.
  */
  static actionAfterOrderLegacy(): void {
    try {
      (window.top as Window & { workspace?: { openAppActivity: (resourceId: string, pk: Record<string, unknown>) => void } })?.workspace?.openAppActivity(this.CONTAS_RESOURCE_ID, {});
    } catch (e) {
      console.warn('[PlgBoletoRapidoUtils] actionAfterOrderLegacy erro:', e);
    }
  }

  static closeToast(component: FoundJnmWebcom82BoletoNotification): void {
    if (component) {
      component.hide();
    }
  }

  static async saveSubmittedForm(): Promise<void> {
    //TODO: implementar listener para o evento de submit do formulário do Marketplace
    ErpUtils.saveSubmittedForm('V1:submitted.pqlfintech');
  }

  static async saveDontShowAgain(): Promise<void> {
    const resourceId = (window as Window & { RESOURCEID?: string }).RESOURCEID || null;
    const codUsuario = (window.top as Window & { CODUSU?: number }).CODUSU || null;

    ErpUtils.saveConfigExibicao(`${this.PQL_VERSION}:${resourceId}.pqlfintech`, String(codUsuario));
  }

  static actionBanner(resourceIdParam?: string, productIdParam?: string): void {
    const resourceId = resourceIdParam || (window as Window & { RESOURCEID?: string }).RESOURCEID || null;
    const productId = productIdParam || Env.APP_ID_MARKETPLACE_BOLETO_RAPIDO;
    
    if (!resourceId) {
      console.warn('[PlgBoletoRapidoUtils] resourceId ausente; evento não disparado');
      return;
    }

    const triggerSource = 'mkp_banner_' + resourceId;


    this.trackEventClick();

    document.dispatchEvent(
      new CustomEvent('mkpCheckoutOpen', {
        detail: { productId, triggerSource },
      })
    );
  }

  static async action(component: FoundJnmWebcom82BoletoNotification): Promise<void> {
    const resourceId = (window as Window & { RESOURCEID?: string }).RESOURCEID || null;
    const productId = Env.APP_ID_MARKETPLACE_BOLETO_RAPIDO;
    console.warn('PlgBoletoRapidoUtils.action - resourceId:', resourceId, 'productId:', productId, 'component:', component);
   
    if (!resourceId) {
      console.warn('[PlgBoletoRapidoUtils] resourceId ausente; evento não disparado');
      return;
    }

    const triggerSource = 'mkp_toast_' + resourceId;


    await this.trackEventClick();

    document.dispatchEvent(
      new CustomEvent('mkpCheckoutOpen', {
        detail: { productId, triggerSource },
      })
    );

    this.closeToast(component);
    ErpUtils.clearLocalStorageConfigItem(`V1:submmited.pqlfintech`);
  }

  static handleCheckboxChange(event: Event, component: FoundJnmWebcom82BoletoNotification): void {
    component.dontShowAgain = (event.target as HTMLInputElement).checked;
    console.warn('Checkbox "Não mostrar novamente" alterado para:', component.dontShowAgain);
    if (component.dontShowAgain) {
      this.saveDontShowAgain();
    }
    this.closeToast(component);
  }

  static async trackEventClick(): Promise<void> {
    try {

      const fintechModuleExists = await ModuleInfoUtils.fintechModuleExists();

      if(fintechModuleExists) {
        return await this.doCallTrackEventServiceBroker();
      }
        
      return await this.doCallTrackEventApi();

    } catch (error) {
      console.warn('[PlgBoletoRapidoUtils] Erro ao registrar evento trackEvent (ignorado):', error);
    }
  }

  private static async doCallTrackEventServiceBroker(): Promise<void> { 
    const resourceId = (window as Window & { RESOURCEID?: string }).RESOURCEID || null;
    
    const eventData = {
      requestBody: {
        chavePlano: "basic",
        resourceId
      }
    };

    await ServiceBrokerCaller.callService('found-jnm-webcom82@TrackEventosSP.trackEvent', eventData);
  }

  private static async doCallTrackEventApi(): Promise<void> { 
    const codUsuario = (window.top as Window & { CODUSU?: number })?.CODUSU;
    const nomeUsuario = (window.top as Window & { NOMEUSU?: string })?.NOMEUSU;
    const parceiro = await ErpUtils.getParceiro();
    const resourceId = (window as Window & { RESOURCEID?: string }).RESOURCEID || null;

    const eventData = {
      idUsuarioExterno: codUsuario,
      nomeUsuarioExterno: nomeUsuario,
      idClienteExterno: parceiro?.codParc,
      nomeClienteExterno: parceiro?.nomeParc,
      chavePlano: "basic",
      metadata: {
        resourceId
      }
    };

    await ServiceBrokerApiCaller.callApi(API_PATHS.TRACK_EVENT, eventData);
  }
}
